import {
  MINI_COG_CLOCK_ANSWERS,
  MINI_COG_RECALL_ANSWERS,
  MINI_COG_WORD_LIST_ANSWERS,
} from '#src/terminology/instruments/instrumentTerminology.ts'
import {
  ownCoding,
  scoreBand,
  scoredItem,
  totalScore,
} from '#src/terminology/instruments/templateParts.ts'
import type {
  InstrumentSection,
  InstrumentTemplate,
} from '#src/terminology/instruments/types.ts'

const CLOCK_DRAWING = ownCoding('mini-cog-clock-drawing', 'Clock Drawing')

const SECTIONS: InstrumentSection[] = [
  {
    id: 'word-registration',
    title: 'Step 1: Word Registration',
    items: [
      scoredItem(
        ownCoding('mini-cog-word-list-version', 'Word List Version'),
        MINI_COG_WORD_LIST_ANSWERS,
        { scaleType: 'Nom', required: false, scored: false }
      ),
    ],
  },
  {
    id: 'clock-drawing',
    title: 'Step 2: Clock Drawing',
    items: [scoredItem(CLOCK_DRAWING, MINI_COG_CLOCK_ANSWERS)],
  },
  {
    id: 'word-recall',
    title: 'Step 3: Word Recall',
    // A checkbox per word: one left unticked was not recalled.
    items: [1, 2, 3].map((word) =>
      scoredItem(
        ownCoding(`mini-cog-word-${word}-recalled`, `Word ${word} Recalled`),
        MINI_COG_RECALL_ANSWERS,
        { required: false }
      )
    ),
  },
]

// Word recall (0-3) plus the clock (0 or 2). An unanswered word scores
// nothing, as an unticked box does on the form, but there is no total
// without the clock.
export const MINI_COG_TEMPLATE: InstrumentTemplate = {
  id: 'mini-cog',
  version: '1',
  panel: ownCoding('mini-cog-panel', 'Mini-Cog'),
  title: 'Mini-Cog',
  copyright: 'Mini-Cog© S. Borson. All rights reserved.',
  reference:
    'https://mini-cog.com/wp-content/uploads/2022/04/Standardized-English-Mini-Cog-1-19-16-EN_v1-low-1-2.pdf',
  sections: SECTIONS,
  total: totalScore({
    templateId: 'mini-cog',
    coding: ownCoding('mini-cog-total', 'Mini-Cog total score'),
    sections: SECTIONS,
    completeness: { allowMissing: 3 },
    rule: (sum) => ({
      ...sum,
      compute: (inputs) =>
        inputs.score(CLOCK_DRAWING) === null ? null : sum.compute(inputs),
    }),
    bands: [
      scoreBand(
        { min: 0, max: 2 },
        'mini-cog-positive',
        'Positive Screen',
        'red'
      ),
      scoreBand(
        { min: 3, max: 5 },
        'mini-cog-negative',
        'Negative Screen',
        'green'
      ),
    ],
  }),
}
